<div class="transaction-item">
    <div class="media">
        <div class="avatar rounded" [ngClass]="{'bg-light-success': percentage > 0, 'bg-light-danger': percentage < 0, 'bg-light-secondary': percentage == 0}">
            <div class="avatar-content">
                <ng-container *ngTemplateOutlet="icon; context: { percentage: percentage}"></ng-container>
            </div>
        </div>
        <div class="media-body">
            <h6 class="transaction-title">{{label}}</h6>
            <small>{{price | currency: 'USD':'symbol':'1.0-2'}}</small>
        </div>
    </div>
    <div class="font-weight-bolder text-secondary" [ngClass]="{'text-success': percentage > 0, 'text-danger': percentage < 0, 'text-secondary': percentage == 0}">{{percentage | number : '1.0-2'}}%</div>
</div>

<ng-template #icon let-percentage="percentage">
    <i *ngIf="percentage < 0" data-feather="trending-down" class="avatar-icon font-medium-3"></i>
    <i *ngIf="percentage > 0" data-feather="trending-up" class="avatar-icon font-medium-3"></i>
    <i *ngIf="percentage == 0" data-feather="minus-square" class="avatar-icon font-medium-3"></i>
</ng-template>